import React, { useEffect } from 'react';
import { di } from 'react-magnetic-di';
import { withAnalyticsContext } from '@atlaskit/analytics-next';
import { AtlassianNavigation, ProductHome } from '@atlaskit/atlassian-navigation';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { JiraServiceManagementIcon, JiraServiceManagementLogo } from '@atlaskit/logo';
import { AvatarMenuV2 } from '@atlassian/help-center-avatar-menu';
import AppSwitcherComponent from './app-switcher';
export interface HeaderProps {
    fetchUser: () => void;
}

const HomeIcon = () => <JiraServiceManagementIcon size="xsmall" appearance="brand" shouldUseNewLogoDesign />;
const HomeLogo = () => <JiraServiceManagementLogo size="xsmall" appearance="brand" shouldUseNewLogoDesign />;

const Home = () => <ProductHome icon={HomeIcon} logo={HomeLogo} href={`${window.location.origin}/jira/your-work`} />;

const Header: React.FC<HeaderProps> = ({ fetchUser }: HeaderProps) => {
    di(AvatarMenuV2, FeatureGates);

    useEffect(() => {
        fetchUser();
    }, [fetchUser]);

    const AppSwitcher = () => (FeatureGates.checkGate('update_jsm_header') ? <AppSwitcherComponent /> : undefined);

    return (
        <AtlassianNavigation
            label="site"
            renderProductHome={Home}
            renderProfile={AvatarMenuV2}
            renderAppSwitcher={AppSwitcher}
            primaryItems={[]}
        />
    );
};

export default withAnalyticsContext({ component: 'Header' })(Header);
